import { useCallback } from "react";
import { dispatchToast } from "../services/toastBus";

// TPX-2486: toasts now live in the single ToastProvider. This hook is a thin forwarder kept so the
// existing call sites keep working unchanged; `Toast` renders null and `container` is ignored.
const NullToast = () => null;

const useToast = () => {
  const showToast = useCallback(
    (message, alertType = "error", container = null, toastDuration = 6000, action = null) => {
      dispatchToast(message, alertType, container, toastDuration, action);
    },
    []
  );

  // No-op kept for compatibility; ToastProvider renders and owns each toast's close ✕.
  const closeToast = useCallback(() => {}, []);

  return {
    Toast: NullToast,
    showToast,
    closeToast,
  };
};

export default useToast;
